import { PageController } from '@client/components/_core/layout/PageController';
import { AttestationCoverageOverlay } from '@client/components/attestations/reporting/AttestationCoverageOverlay';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/attestations/rounds/$roundId/coverage')({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'Coverage',
        },
        featureFlag: 'enable-attestation-reporting',
    },
    component: RouteComponent,
});

function RouteComponent() {
    const { roundId } = Route.useParams();
    return (
        <PageController route={Route}>
            <AttestationCoverageOverlay roundId={roundId} />
        </PageController>
    );
}
